<template>
    <div
        :ref="sectionRef"
        :class="[
            'block mx-auto bg-white   shadow-lg page',
            {
                'w-a4w h-a4h': isPortraitMode,
                'h-a4w w-a4h ': !isPortraitMode
            }
        ]"
    >
        <h2
            v-if="title"
            class="block mb-5 text-xl font-semibold text-right text-output-primary pt-output px-output"
        >
            {{ title }}
        </h2>
        <div
            ref="content"
            v-if="!noPadding"
            :class="[
                'relative w-full pb-output  px-output',
                {
                    'h-full': fullHeight
                }
            ]"
        >
            <slot></slot>
        </div>
        <div
            :class="[
                'relative w-full',
                {
                    'h-full': fullHeight
                }
            ]"
        >
            <slot name="noPadding"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        orientation: {
            type: String,
            default: "portrait"
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        fullHeight: {
            type: Boolean,
            default: false
        },
        // renderTrigger: {
        //     type: Array
        // },
        sectionRef: {
            type: String
        }
    },
    watch: {
        renderTrigger: {
            immediate: false,

            handler() {
                this.$forceUpdate();
                this.$once("hook:updated", () => {
                    this.$emit(
                        "page-updated",
                        this.$refs?.content.clientHeight
                    );
                });
            }
        }
    },
    mounted() {
        window.addEventListener("beforeprint", this.printOrientation);
        window.addEventListener("afterprint", this.screenOrientation);
    },
    methods: {
        printOrientation() {
            this.print = true;
        },
        screenOrientation() {
            this.print = false;
        }
    },
    computed: {
        isPortraitMode() {
            // if (this.print) return true;
            return this.orientation === "portrait";
        }
    },

    destroyed() {
        window.removeEventListener("beforeprint", this.printOrientation);
        window.removeEventListener("screenOrientation", this.screenOrientation);
    },
    data() {
        return {
            renderTrigger: "",
            counter: 0,
            print: false
        };
    }
};
</script>

<style scoped>
@media not print {
    .page:not(:last-child) {
        margin-bottom: 50px;
        box-shadow: 0 5px 10px rgba(154, 160, 185, 0.05),
            0 15px 40px rgba(166, 173, 201, 0.2);
    }
}
@media print {
    .page {
        margin: 0;
        padding: 0;
    }
}
</style>
